import { taggedTemplateLiteral as _taggedTemplateLiteral, objectSpread2 as _objectSpread2 } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React__default from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import index from '../../node_modules/react-select/dist/react-select.browser.esm.js';
import Theme from '../../Theme/index.js';

var _templateObject;
var errorStyles = {
  border: function border(_ref) {
    var hasError = _ref.hasError;
    return hasError && "1px solid ".concat(Theme.colors.danger);
  },
  dangerLight: function dangerLight(_ref2) {
    var hasError = _ref2.hasError;
    return hasError && "".concat(Theme.colors.dangerLight);
  },
  danger: function danger(_ref3) {
    var hasError = _ref3.hasError;
    return hasError && "".concat(Theme.colors.danger);
  }
};
var StyledSelect = styled(index)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  .Select__control {\n    cursor: pointer;\n    border-radius: 0;\n    border: ", ";\n    background-color: ", ";\n  }\n  .Select__placeholder {\n    color: ", ";\n  }\n  .Select__indicators {\n    .Select__indicator-separator {\n      background-color: ", ";\n    }\n    svg {\n      fill: ", ";\n    }\n  }\n"])), errorStyles.border, errorStyles.dangerLight, errorStyles.danger, errorStyles.danger, errorStyles.danger);
var selectStyles = {
  placeholder: function placeholder(styles) {
    return _objectSpread2(_objectSpread2({}, styles), {}, {
      fontSize: 15,
      color: Theme.colors.blueGrey
    });
  }
};
var SelectField = function SelectField(_ref4) {
  var options = _ref4.options,
    field = _ref4.field,
    form = _ref4.form,
    errors = _ref4.errors,
    touched = _ref4.touched,
    placeholder = _ref4.placeholder;
  var hasError = errors[field.name] && touched[field.name];
  return /*#__PURE__*/React__default.createElement(StyledSelect, {
    options: options,
    name: field.name,
    value: options ? options.find(function (option) {
      return option.value === field.value;
    }) : "",
    onChange: function onChange(option) {
      return form.setFieldValue(field.name, option.value);
    },
    onBlur: field.onBlur,
    classNamePrefix: "Select",
    placeholder: placeholder || "Please Select",
    hasError: hasError,
    styles: selectStyles
  });
};
SelectField.propTypes = {
  options: PropTypes.arrayOf(PropTypes.shape({
    value: PropTypes.string,
    label: PropTypes.string
  })),
  field: PropTypes.shape({
    value: PropTypes.string,
    name: PropTypes.string
  }),
  errors: PropTypes.object,
  touched: PropTypes.object,
  placeholder: PropTypes.string
};

export { StyledSelect, SelectField as default, errorStyles, selectStyles };
